import { render, staticRenderFns } from "./support.vue?vue&type=template&id=55eca42c&scoped=true&"
var script = {}
import style0 from "./support.vue?vue&type=style&index=0&id=55eca42c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55eca42c",
  null
  
)

export default component.exports